export default __webpack_public_path__ + "static/media/ra.998eaf86.png";